module.exports = __webpack_public_path__ + "img/practice-black.1b94b08a.svg";